import styled from 'styled-components';

export const ListInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
